module.exports = __webpack_public_path__ + "static/media/path-4-copy-2@3x.94668f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/path-4-copy-2@3x.png
// module id = 28
// module chunks = 19